import {useQuery} from '@tanstack/react-query';
import {useUserInfoQueryOptions} from '~/entities/user';
import {Intercom} from '../ui/SupportPage';

export function useIntercomUserInfo({enabled}: {enabled: boolean}) {
    return useQuery({
        ...useUserInfoQueryOptions(),
        enabled: enabled,
        select: (userinfo): Intercom.UserInfo => ({
            userId: `${userinfo.id}`,
            name: fullNameFormat(userinfo.dossier?.personal.givenName, userinfo.dossier?.personal.familyName),
            email: userinfo.verifiedEmail ?? undefined,
            userHash: userinfo.intercomHash ?? undefined,
            phone: userinfo.username,
        }),
    });
}

function fullNameFormat(name: string | undefined | null, familyName: string | undefined | null): string | undefined {
    if (!name && !familyName) {
        return undefined;
    }
    if (!familyName) {
        return name as string;
    }
    if (!name) {
        return familyName;
    }
    return `${familyName}, ${name}`;
}
